// The one Premium price list, shared by /pricing, the /welcome plan step and the
// upgrade dialog. Must match the Stripe prices
// (backend/src/scripts/create-premium-prices.js); the keys are the `interval`
// that startPremiumCheckout takes.
export const PREMIUM_PRICES = {
  monthly: { perMonth: 24, total: 24, label: "Monthly", every: "a month" },
  quarterly: { perMonth: 19, total: 57, label: "3 months", every: "every 3 months" },
  semiannual: { perMonth: 16, total: 96, label: "6 months", every: "every 6 months" },
  yearly: { perMonth: 12, total: 144, label: "Yearly", every: "a year" },
}
export const BILLING_KEYS = Object.keys(PREMIUM_PRICES)
export const DEFAULT_BILLING = "yearly"
export const TRIAL_DAYS = 7

// percent off the monthly price, 0 for monthly itself
export const savingFor = (key) =>
  Math.round((1 - PREMIUM_PRICES[key].perMonth / PREMIUM_PRICES.monthly.perMonth) * 100)

// "$144 a year", "$57 every 3 months"
export const billedText = (key) => `$${PREMIUM_PRICES[key].total} ${PREMIUM_PRICES[key].every}`

// Only what the code delivers today (docs/hero-redesign-plan.md §5). Planned
// features are listed separately and labeled; nothing unbuilt is sold.
export const PREMIUM_FEATURES = [
  "Refresh your FounderAssist plan up to 3 times a day",
  "Unlimited messages, with read receipts",
  "Suggested founders and ideas, refreshed anytime",
  "Listed in the founder grid",
  "Advanced filters: stage, industry and keywords",
  "Up to 50% off partner tools",
]
export const PREMIUM_PLANNED = ["Each refresh picks the day's tasks, people and reading", "See who viewed your profile"]
